<template>
  <div
    id="weather_condition"
    class="roundedCardGreen"
    :style="{
      height: '100%',
      'border-radius': '20px',
      background: imglist.bg,
    }"
  >
    <div style="display: grid; height: 100%; align-items: center">
      <div style="height: 50px" class="div-row al-center">
        <div class="mt-2" style="width: 50px">
          <img width="100%" :src="imgGift1" />
        </div>

        <div class="ml-2 mt-2" style="width: 80%">
          <h3 class="text_1">{{ head }}</h3>
        </div>
      </div>
      <div class="text2-bottom">
        <div class="div-row al-center">
          <h1 class="text_2 mr-2" :style="{ color: imglist.color }">
            {{ value }}
          </h1>
          <h3
            v-if="head == 'Wind Direction'"
            class="text_3 thFontthai"
            :style="{ color: imglist.color }"
          >
            {{ unit }}
          </h3>
          <h1 v-else class="text_2" :style="{ color: imglist.color }">
            {{ unit }}
          </h1>
        </div>
      </div>
      <div class="text2-bottom">
        <div style="font-weight: 600" class="div-row text_detail_th_wt al-center thFontthai">
          {{ detail }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["head", "detail", "imgGift1", "imglist", "value", "unit"],
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Charm:wght@700&family=Kodchasan:wght@500&display=swap");
@import "./../aqi.scss";

.div-row {
  display: flex;
  justify-content: center;
}
// .text2-bottom {
//   height: calc(100% - 50px);
//   display: grid;
// }
.roundedCardGreen-header {
  background: rgba(98, 201, 147, 0.9);
  border-radius: 50px;
  padding: 10px;
}
.textSpansub {
  font-size: 1vw;
  font-weight: 400;
}
.headCardTe {
  //   font-size: 1.6rem;
  font-weight: 800;
}
.ml-55 {
  margin-left: 55%;
}
:fullscreen {
  .ml-55 {
    margin-left: 68%;
  }
  // .text_detail_th {
  //   font-size: 1vw;
  //   margin-top: 20px;
  // }
}
</style>